import { network } from 'services/network';

export const getTopDurationOverrunRisk = (params) => {
    return network.post('api/bo/getTopDurationOverrunRisk', params).then((response) => {
        return response.data;
    });
};
